var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.text
    ? _c(
        "div",
        { staticClass: "qr-code-container" },
        [
          _c("img", { staticClass: "qr-code-img", attrs: { src: _vm.qrImg } }),
          _vm._v(" "),
          _vm._t("default", function () {
            return [
              _vm.hint
                ? _c("div", {
                    staticClass: "qr-code-hint",
                    domProps: { innerHTML: _vm._s(_vm.hint) },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }